import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { DeleteAllItemsMutationResponse, DeleteAllItemsQueryParams, DeleteAllItems400, DeleteAllItems401, DeleteAllItems403, DeleteAllItems422, DeleteAllItems429, DeleteAllItems500 } from "../types/DeleteAllItems";

/**
 * @link /api/purchase-tenders/v1/items
 */

export function useDeleteAllItems <TData = DeleteAllItemsMutationResponse, TError = DeleteAllItems400 | DeleteAllItems401 | DeleteAllItems403 | DeleteAllItems422 | DeleteAllItems429 | DeleteAllItems500>(params: DeleteAllItemsQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "delete",
        url: `/api/purchase-tenders/v1/items`,
        
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
